module.exports = __webpack_public_path__ + "static/img/avatar_user_female.78ccfc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/publicResource/common/img/avatar_user_female.png
// module id = AWLp
// module chunks = 25 37 41 97